module.exports = __webpack_public_path__ + "static/media/sample_lmconsignee.e7da436c.csv";